import styled from '@emotion/styled';

const DialogTitle = styled('h6')`
  color: ${({ theme }) => theme.secondary.base};
  font-family: ${({ theme }) => theme.fonts.algebraLight};
  font-size: 32px;
  font-weight: 300;
  margin-top: 0;
  margin-bottom: 16px;
  margin-right: 40px;
`;

export default DialogTitle;
